import useSwr from "@/core/composables/swr/useSwr";
import {dosageApi} from "@/container";
import {ProductDose} from "@/product/interfaces/ProductDose";

/**
 * SWR composable to fetch dosage forms.
 */
const useProductDoses = () => {
    return useSwr<ProductDose[]>("products/doses", () => {
        return dosageApi().productDoses();
    });
};

export default useProductDoses;
